module.exports = __webpack_public_path__ + "img/Aquila.c8f81511.png";